import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const SkinAnalyserWrapper = styled.div`
  padding: 0.5rem;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  border-radius: 0.5rem;
  box-shadow: 0px 1px 2px 0px rgba(71, 71, 71, 0.06),
    0px 4px 8px 0px rgba(71, 71, 71, 0.1);

  flex-direction: column;
  padding: 0;
  margin-top: -0.5rem;
  margin-bottom: 1.5rem;

  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    margin: 0.5rem 0;

    margin-top: -0.5rem;
    margin-bottom: 1.5rem;
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.lg}) {
    margin: 0;
    margin-bottom: 3rem;
    flex-direction: row;
  }
`;

export const Image = styled.img`
  width: 100%;
`;
